var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('b-button',{attrs:{"variant":"outline","size":"sm","block":_vm.showCollapseButtonText},on:{"click":function($event){return _vm.$emit('input', !_vm.collapsed)}}},[_vm._v(" "+_vm._s(_vm.buttonText)+_vm._s(_vm.collapsed ? '▼' : '▲')+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }